(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('LeadOfferRoomType', LeadOfferRoomType);

    LeadOfferRoomType.$inject = ['$resource'];

    function LeadOfferRoomType ($resource) {
        var resourceUrl =  'api/lead-offer-room-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
